<template>
  <div>
    <div class="sift">
      <div class="title">报表查询</div>
      <div class="inquire">
        <el-form :model="formInline" class="demo-form-inline" label-width="80px" size="mini" inline @submit.native.prevent>
          <el-form-item>
            <strong slot="label">日期</strong>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width:240px"
              @change="handleChange"
              :picker-options="pickerOptions"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="cfOrgRept.flowRepttype === '2'">
            <strong slot="label">客户</strong>
            <el-input type="text" v-model="khmc" placeholder="请输入客户名称" />
          </el-form-item>
          <el-form-item v-for="(item, index) in cfOrgRept.cfFlowReptcontList" :key="item.cfFlowReptcontId" v-if="item.isSearch == '0'">
            <strong slot="label">{{item.label}}</strong>
            <el-input v-model="formInline.query[index].searchValue" placeholder="请输入产品名称" clearable  @keyup.enter.native="inquire" @clear="inquire" style="width:240px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
            <el-button type="warning" icon="el-icon-download" @click="exportExcel">导出</el-button>
            <!-- <download-excel
              class="export-excel-wrapper"
              :data="tableData"
              :fields="json_fields"
              :header="cfOrgRept.showName"
              :name="`${cfOrgRept.showName}.xls`"
              style="margin-left: 10px;display: inline-block;"
            >
              <el-button type="warning" icon="el-icon-download">导出</el-button>
            </download-excel> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <el-tabs type="border-card" v-model="activeId" @tab-click="handleClick">
      <div v-if="!orgReptList.length" style="color:#999">暂无数据~</div>
      <el-tab-pane v-for="(item, index) in orgReptList" :key="index" :label="item.showName" :name="item.cfFlowReptId + ''"> -->
    <div class="mutiple-contain" style="height:100%">
      <!-- <div class="mutiple-left" ref="querytree"> -->
      <div class="mutiple-left" v-if="cbussDimeTree.length">
        <el-select size="mini" style="width:180px" v-model="activeNames" placeholder="请选择资源类型" @change="changeCbResourceType">
          <el-option v-for="(value, key) in cBussDimeMap" :key="key" :label="key" :value="key"></el-option>
        </el-select>

        <el-collapse style="width: 180px;">
          <el-collapse-item :title="item.label" :name="index + 1" v-for="(item, index) in cbussDimeTree" :key="index">
            <el-tree
              :data="item.children"
              :props="defaultProps"
              @node-click="handleNodeClick1($event, index)"
              default-expand-all
              :ref="'tree' + (index + 1)"
              :expand-on-click-node="false"
              highlight-current
              node-key="value">
            </el-tree>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="mutiple-right">
        <el-table
          id="educe-table"
          border
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          :cell-style="{'vertical-align':'top'}"
          :max-height="tableHeight"
          v-if="$route.query.cfFlowReptId == cfOrgRept.cfFlowReptId && cfOrgRept.isGroup != '0'"
          v-loading="loading"
          :row-class-name="rowClass"
          default-expand-all
          row-key="id"
          :tree-props="{children: 'secondList', hasChildren: 'hasSecondList'}"
          :show-summary="cfOrgRept.flowRepttype == '6' || cfOrgRept.flowRepttype == '7'"
          :summary-method="getSummaries"
        >
          <el-table-column prop="name" align="center" label="名称" min-width="100" v-if="cfOrgRept.flowRepttype != '6' && cfOrgRept.flowRepttype != '7'"></el-table-column>
          <el-table-column v-for="(val, id) in cfOrgRept.cfFlowReptcontList" :key="id" :prop="val.prop + val.cfFlowReptcontId" :label="val.label" :align="(cfOrgRept.flowRepttype == '6' || cfOrgRept.flowRepttype == '7' )? 'center' : 'right'" header-align="center" :min-width="cfOrgRept.flowRepttype == '4' ? '275' : '160'"  :class-name="val.isStat == '0' ? 'stat' : ''">
            <template slot-scope="scope">
              <div v-if="cfOrgRept.flowRepttype == '6' || cfOrgRept.flowRepttype == '7'">
                <template v-if="val.worktype == 'b'">{{scope.row.b[val.prop]}}</template>
                <template v-else-if="val.worktype == 'n'">{{scope.row.n[val.prop]}}</template>
                <template v-else-if="val.worktype == 'p'">{{scope.row.p[val.prop]}}</template>
                <template v-else-if="val.worktype == 'c'">{{dealCalc(scope.row.c,val.cfFlowReptcontId)}}</template>
                <template v-else>{{scope.row.b[val.prop]}}</template>
              </div>
              <div v-for="(el, cfFlowReptcontId) in scope.row.list" :key="cfFlowReptcontId" v-if="cfOrgRept.flowRepttype != '6' && cfOrgRept.flowRepttype != '7' && el.cfFlowReptcontId == val.cfFlowReptcontId">
                <template v-if="cfOrgRept.flowRepttype != '4'">
                  <div v-if="val.labelType == '4'">{{el.reptValue | comdify}}</div>
                  <div v-else-if="val.labelType == '5'">{{el.reptValue | filter_handleTimeRange}}</div>
                  <div v-else-if="el.subdealtype == '70'" style="display:flex;justify-content: flex-end">
                    <div style="margin-right: 10px">
                      出勤
                      <span style="color:blue;cursor: pointer" @click="getLogs(el, '1')">{{el.reptValue}}</span>
                    </div>
                    <div>
                      异常
                      <span style="color:red;cursor: pointer" @click="getLogs(el, '2')">{{el.reptValue2}}</span>
                    </div>
                  </div>
                  <div v-else>{{el.reptValue}}</div>
                </template>
                <el-table
                  v-if="cfOrgRept.flowRepttype == '4'"
                  :data="el.workList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
                >
                  <el-table-column prop="name" label="名称" header-align="center" min-width="100">
                    <template slot-scope="scope1">
                      <a class="link" @click="handleDetail(scope1.row)" style="user-select: none;">{{scope1.row.name}}</a>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ptotal" label="金额" align="right" min-width="150" header-align="center">
                    <template slot-scope="scope1">
                      {{scope1.row.ptotal | comdify}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <template v-if="$route.query.cfFlowReptId == cfOrgRept.cfFlowReptId && cfOrgRept.isGroup == '0'">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="grid-content">
                <el-table
                  id="educe-table"
                  border
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
                  :cell-style="{'vertical-align':'top'}"
                  :max-height="tableHeight"
                  v-loading="loading"
                  ref="monthlyPlanTable"
                  highlight-current-row
                  @row-click="handleRowClick"
                >
                  <el-table-column prop="name" label="名称"></el-table-column>
                  <el-table-column prop="quantity" label="数量" align="right"></el-table-column>
<!--                  <el-table-column prop="cost" label="成本" align="right">-->
<!--                    <template slot-scope="scope">-->
<!--                      {{scope.row.cost | comdify('no')}}-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column prop="total" label="金额" align="right">
                    <template slot-scope="scope">
                      {{scope.row.total | comdify('no')}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <div class="title">{{kindName}}</div>
                <el-table
                  id="educe-table"
                  border
                  :data="orgReptChildren"
                  tooltip-effect="dark"
                  style="width: 100%"
                  v-loading="loading"
                  :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
                  :cell-style="{'vertical-align':'top'}"
                  :max-height="tableHeight - 30"
                >
                  <el-table-column prop="name" label="名称">
                    <template slot-scope="scope">
                      <div class="link" @click="clickName(scope.row)">{{scope.row.name}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="quantity" label="数量" align="right"></el-table-column>
<!--                  <el-table-column prop="cost" label="成本" align="right">-->
<!--                    <template slot-scope="scope">-->
<!--                      {{scope.row.cost | comdify('no')}}-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column prop="total" label="金额" align="right">
                    <template slot-scope="scope">
                      {{scope.row.total | comdify('no')}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </template>
      </div>
    </div>
      <!-- </el-tab-pane>
    </el-tabs> -->
    <!-- 考勤明细 -->
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogVisible"
      append-to-body
      top="59px"
      width="70%">
      <div style="height:100%;overflow: auto">
        <el-table
          border
          :data="attendLogs"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          v-loading="loading1"
        >
          <el-table-column prop="attendDate" label="考勤日期"></el-table-column>
          <el-table-column prop="attendShiftInfo" label="班次信息"></el-table-column>
          <el-table-column prop="attendResult" label="考勤结果">
            <template slot-scope="scope">
              {{ scope.row.attendResult == '0' ? '休假' : (scope.row.attendResult == '1' ? '正常' : '异常') }}
            </template>
          </el-table-column>
          <el-table-column prop="attendResult" label="考勤日志">
            <template slot-scope="scope">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in scope.row.attendLogs" :key="index" :timestamp="item.checkInTime">
                  <div>
                    {{item.attendType == '1' ? '上班' : (item.attendType == '2' ? '下班' : '')}}
                    <el-tag size="mini" :type="item.attendStatus == '1' ? 'danger' : (item.attendStatus == '2' ? 'warning' : '')">{{item.attendStatus == '0' ? '正常' : (item.attendStatus == '1' ? '非正常' : (item.attendStatus == '2' ? '旷工' : ''))}}</el-tag>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="dialog-content">
        <div class="dialog-row">
          <div class="row-left">考勤日期：</div>
          <div class="row-right">2024-03-01</div>
        </div>
        <div class="dialog-row">
          <div class="row-left">班次信息：</div>
          <div class="row-right">09:00-17:30</div>
        </div>
        <div class="dialog-row">
          <div class="row-left">考勤结果：</div>
          <div class="row-right">正常</div>
        </div>
        <div class="dialog-row">
          <div class="row-left">考勤日志：</div>
          <div class="row-right">
            <div class="log-list" v-for="(item, index) in attendLogs" :key="index">
							<div class="list-left">
								<div class="list-dot"></div>
								<div class="list-line"></div>
							</div>
							<div class="list-right">
								<div class="list-text">
									<div class="list-row">
										<div class="list-row-text">{{ item.attendType == '1' ? '上班' : '下班'}}</div>
										<div class="list-row-data">
											{{ item.checkInTime ? parseTime(item.checkInTime, '{h}:{i}') : '' }}
											<div class="list-status" v-if="item.attendStatus != '0' ">{{ item.attendStatus == '2' ? '旷工' : (item.attendStatus == '1' ? (item.attendType == '1' ? '迟到' : '早退') : '')}}</div>
										</div>
									</div>
									<div class="clock-text">
										{{ item.attendPozStatus == '0' ? '考勤范围内' : (item.attendPozStatus == '1' ? '考勤范围外' : '')}}
									</div>
								</div>

							</div>
						</div>
          </div>
        </div>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 汇总行 -->
    <el-dialog v-dialog-drag
      :title="rowTitle"
      :visible.sync="dialogRowVisible"
      append-to-body
      top="59px"
      width="90%">
      <div style="height:100%;overflow: auto">
        <el-table
          border
          :data="rowTable"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          v-loading="loading2"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column v-for="(val, id) in cfOrgRept.cfFlowReptcontList" :key="id" :prop="val.prop" :class-name="val.isStat == '0' ? 'stat' : ''" :label="val.label" align="center" header-align="center" :min-width="'160'">
            <template slot-scope="scope">
              <!-- <div v-if="cfOrgRept.flowRepttype == '6' || cfOrgRept.flowRepttype == '7'"> -->
                <template v-if="val.worktype == 'b'">{{scope.row.b[val.prop]}}</template>
                <template v-else-if="val.worktype == 'n'">{{scope.row.n[val.prop]}}</template>
                <template v-else-if="val.worktype == 'p'">{{scope.row.p[val.prop]}}</template>
                <template v-else-if="val.worktype == 'c'">{{dealCalc(scope.row.c,val.cfFlowReptcontId)}}</template>
                <template v-else>{{scope.row.b[val.prop]}}</template>
              <!-- </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRowVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import qs from 'qs'
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
import Decimal from 'decimal.js';
// import XLSX from 'xlsx'

  export default {
    data() {
      return {
        tableData: [],
        orgReptList: [],
        activeId: '',
        date: [],
        khmc: null,
        dialogVisible: false,
        productsList: [],
        pageNum1: 1,
        pageSize1: 10,
        total1: 0,
        loading: true,
        loading1: true,
        ofoWorkId: '',
        tableHeight: window.innerHeight - 160,
        ofoFlowWork: {},
        proTotal: {
          ctotal: 0,
          ctotalNovat: 0,
          ctotalVat: 0,
          ptotal: 0,
          ptotalNovat: 0,
          ptotalVat: 0,
        },
        subTotal: {
          ctotal: 0,
          ctotalNovat: 0,
          ctotalVat: 0,
          ptotal: 0,
          ptotalNovat: 0,
          ptotalVat: 0,
        },
        navList: [],
        isActive: 0,
        thingsList: [],
        pageNum2: 1,
        pageSize2: 10,
        total2: 0,
        title: '考勤明细',
        attendLogs: [{},{}],
        cfOrgRept: {},
        formInline: {
          query: []
        },
        json_fields: {},
        orgReptChildren: [],
        rowTitle: '',
        dialogRowVisible: false,
        loading2: true,
        rowTable: [],
        kindName: '',
        currentRow: {},
        activeNames: [],
        cbussDimeTree: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        cBussDimeMap:{}
      }
    },
    created () {
      // console.log(111);
      this.date = [this.parseTime(new Date().getTime(), '{y}-{m}-{d}'), this.parseTime(new Date().getTime(), '{y}-{m}-{d}')]
      if(this.$route.path == '/report/org') {
        this.getList()
      }

      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 160;
      })
      window.onresize = () => {   //屏幕尺寸变化就重新赋值
        return (() => {
          this.tableHeight = window.innerHeight - 160;
        })()
      }
    },
    updated(){
      this.$nextTick(() => {
        // console.log(this.$refs.table);
        // if(this.$refs) {
        //   this.$refs.table[0].doLayout()
        // }

          // table是在表格中ref=‘table’
          // doLayout	对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
      })
    },
  methods: {
    handleCalcu (calcu) {
        if(calcu == '1') {
          return '+'
        }else if(calcu == '2') {
          return '-'
        }else if(calcu == '3') {
          return '*'
        }else if(calcu == '4') {
          return '/'
        }else {
          return ''
        }
      },
    dealCalc (obj, id) {
      const result = ''
      try {
        if (obj && obj[id + ''] && obj[id + ''].length) {
          const list = obj[id + '']
          const arr = []
          const length = list.length
          for (let i = 0; i < (length - 1); i++) {
            arr.push(list[i].brackets && list[i].brackets.includes('(') ? list[i].brackets : '', list[i].value, list[i].brackets && list[i].brackets.includes(')') ? list[i].brackets : '', this.handleCalcu(list[i].calcu))
          }
          arr.push(list[length - 1].brackets && list[length - 1].brackets.includes('(') ? list[length - 1].brackets : '', list[length - 1].value, list[length - 1].brackets && list[length - 1].brackets.includes(')') ? list[length - 1].brackets : '')

          // eslint-disable-next-line no-eval
          return eval(arr.join('')).toFixed(2)
        }
      } catch (ignore) {
        console.error('计算自定义字段失败')
        console.error(id, obj)
      }

      return result
    },
      getSummaries(param) {
        const { columns, data } = param;
        // console.log(columns);

        const sums = [];
        columns.forEach((column, index) => {
				  if (index === 0) {
				    sums[index] = '合计';
				    return;
				  }
          let worktype = this.cfOrgRept.cfFlowReptcontList.find(val => (val.prop + val.cfFlowReptcontId) == column.property).worktype
          // console.log(worktype);

          if(worktype == null)worktype = 'b'
          // console.log(data);
          // if(column.property && column.property.includes('_')) {
            // console.log(column.property.split('_')[0]);
          // }


          if (column.className === 'stat') {
            const values = data.map(item => Number(item[worktype][column.property.replace(/\d+/g, '')]));
            let v = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            try {
              v = v.toFixed(2)
            }catch (e) {
              console.log(e)
            }
            sums[index] = v
          }
				});
        // console.log(sums);

				return sums
      },
      handleRowClick(row, column, event) {
        // console.log(row);
        this.orgReptChildren = row.children
        this.kindName = row.kindName
        this.currentRow = row
      },
      clickName(row) {
        this.dialogRowVisible = true
        this.rowTitle = row.name
        // console.log(row);
        this.getRowOrgRept(row.id)
      },
    exportExcel() {
      // 1.生成Excel工作簿对象 - 使用raw: true保持原始字符串
      var wb = XLSX.utils.table_to_book(
        document.querySelector('#educe-table'),
        { raw: true }  // 这个选项确保单元格值保持原始字符串，不进行类型转换
      );

      var firstSheet = wb.Sheets[wb.SheetNames[0]];
      this.dealCellObj(firstSheet);

      // 获取二进制字符串作为输出
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array',
      });

      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          this.cfOrgRept.showName + '.xlsx'
        );
      } catch (e) {
        if (typeof console != 'undefined') console.log(e, wbout);
      }
      return wbout;
    },

    dealCellObj(firstSheet) {
      for (var cell in firstSheet) {
        if (cell[0] === '!') continue;

        var cellObj = firstSheet[cell];

        if (cellObj.v !== undefined && cellObj.v !== null) {
          var originalStr = cellObj.v.toString().trim();

          if (originalStr === '') continue;

          // 判断是否是日期格式字符串
          else if (this.isDateFormat(originalStr)) {
            // 直接输出为字符串，保持原始格式
            cellObj.t = 's'; // 字符串类型
            cellObj.v = originalStr;
            console.log(`${cell}: 保持日期字符串格式`, originalStr);
          }
          // 处理带逗号的数字格式（如 "56,841.04"）
          else if (this.isNumberWithCommas(originalStr)) {
            // 移除逗号，转换为数字
            var cleanStr = originalStr.replace(/,/g, '');
            var numValue = parseFloat(cleanStr);

            if (!isNaN(numValue)) {
              cellObj.t = 'n';
              cellObj.v = numValue;

              // 使用原始字符串判断小数位数（不带千分位）
              if (originalStr.includes('.')) {
                var fractionPart = originalStr.split('.')[1];

                if (/^0+$/.test(fractionPart)) {
                  // 小数全是0，显示为整数
                  cellObj.z = '0';
                  console.log(`${cell}: 数字(整数)`, originalStr, '→', numValue);
                } else {
                  var trimmedFraction = fractionPart.replace(/0+$/, '');
                  if (trimmedFraction.length > 0) {
                    // 有有效小数，按实际小数位数显示
                    cellObj.z = '0.' + '0'.repeat(trimmedFraction.length);
                    console.log(`${cell}: 数字(小数${trimmedFraction.length}位)`, originalStr, '→', numValue);
                  } else {
                    cellObj.z = '0';
                    console.log(`${cell}: 数字(整数)`, originalStr, '→', numValue);
                  }
                }
              } else {
                // 整数
                cellObj.z = '0';
                console.log(`${cell}: 数字(整数)`, originalStr, '→', numValue);
              }
            }
          }
          // 判断是否是数字
          else if (/^-?\d+(\.\d+)?$/.test(originalStr)) {
            // 长数字处理（11位以上纯数字）
            if (/^\d+$/.test(originalStr) && originalStr.length >= 11) {
              cellObj.t = 's';
              cellObj.z = '@';
              cellObj.v = originalStr;
            }
            else {
              var numValue = parseFloat(originalStr);
              if (!isNaN(numValue)) {
                cellObj.t = 'n';
                cellObj.v = numValue;

                // 使用原始字符串判断小数位数
                if (originalStr.includes('.')) {
                  var fractionPart = originalStr.split('.')[1];

                  if (/^0+$/.test(fractionPart)) {
                    cellObj.z = '0';
                    console.log(`${cell}: 小数全是0，显示为整数`, originalStr);
                  } else {
                    var trimmedFraction = fractionPart.replace(/0+$/, '');
                    if (trimmedFraction.length > 0) {
                      cellObj.z = '0.' + '0'.repeat(trimmedFraction.length);
                      console.log(`${cell}: 有效小数 ${trimmedFraction.length}位`, originalStr, '→', cellObj.z);
                    } else {
                      cellObj.z = '0';
                      console.log(`${cell}: 去掉末尾0后变整数`, originalStr);
                    }
                  }
                } else {
                  cellObj.z = '0';
                }
              }
            }
          }
        }
      }
    },
    // 判断是否带千位分隔符的数字
    isNumberWithCommas(str) {
      // 匹配带千位分隔符的数字格式
      // 例如：1,234、12,345.67、1,234,567.89 等
      const pattern = /^-?\d{1,3}(,\d{3})*(\.\d+)?$/;
      return pattern.test(str);
    },
    // 辅助函数：判断是否是日期格式
    isDateFormat(str) {
      // 常见日期格式正则
      const datePatterns = [
        /^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/,// yyyy-mm-dd 或 yyyy/mm/dd
        /^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/,// dd-mm-yyyy 或 mm-dd-yyyy
        /^\d{4}年\d{1,2}月\d{1,2}日$/,// yyyy年mm月dd日
        /^\d{1,2}[-/]\d{1,2}[-/]\d{2}$/,// dd-mm-yy 或 mm-dd-yy
        /^\d{4}-\d{1,2}-\d{1,2}[T\s]\d{1,2}:\d{1,2}(:\d{1,2})?$/, // ISO日期时间
        /^\d{1,2}:\d{1,2}(:\d{1,2})?$/,// 时间格式
        /^\d{4}[-/]\d{1,2}[-/]\d{1,2}\s+\d{1,2}:\d{1,2}(:\d{1,2})?$/ // 日期+时间
      ];
      return datePatterns.some(pattern => pattern.test(str));
    },
      // 导出
      download() {
        this.$confirm(`此操作将导出${this.cfOrgRept.showName}模板, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          // let tableData = row.dime.split(', ')
          let workSheet = XLSX.utils.aoa_to_sheet(this.tableData);
          let bookNew = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(bookNew, workSheet, this.cfOrgRept.showName) // 工作簿名称
          let name = this.cfOrgRept.showName + '.xlsx'
          XLSX.writeFile(bookNew, name) // 保存的文件名
        }).catch(() => {
        });
      },
      // 获取考勤明细
      getLogs(el, attendResult) {
        // console.log(el);
        this.dialogVisible = true
        this.loading1 = true
        this.$http.get(url.getAttendUserLogs, {params: {
          bussId: el.id,
          beginTime: this.date ? this.date[0] : '',
          endTime: this.date ? this.date[1] : ''
        }}).then(res => {
          this.attendLogs = res.data.data.filter(item => item.attendResult == attendResult)
          this.loading1 = false
        })
      },
      rowClass({row, column, rowIndex, columnIndex}){
        if(row.name == '合计') {
          return 'fixed-row'
        }
      },
      getList() {
        this.$http.get(url.getCfOrgReptList).then(res => {
          if(res.data.code == 200) {
            this.orgReptList = res.data.data
            if(this.orgReptList.length) {
              this.cfOrgRept = this.orgReptList.find(item => item.cfFlowReptId == this.$route.query.cfFlowReptId)
              this.formInline.query = this.cfOrgRept.cfFlowReptcontList.map(item => {
                return {
                  ...item,
                  searchValue: ''
                }
              })
              this.activeId = this.cfOrgRept.cfFlowReptId

              this.isActive = this.orgReptList.findIndex(item => item.cfFlowReptId == this.$route.query.cfFlowReptId)
              // console.log(this.$route.query);
              this.initCbussDimeQuery()
            }
          }
        })
      },
      handleDetail(item) {
        // this.productsList = this.thingsList = []
        // this.title = item.name
        // this.dialogVisible = true
        // this.ofoWorkId = item.ofoWorkId
        // this.$http.get(url.getFlowDealAndWork, {params: {ofoWorkId: this.ofoWorkId}}).then(res => {
        //   if(res.data.code == 200) {
        //     // this.ofoFlowDeal = res.data.data.ofoFlowDeal
        //     this.ofoFlowWork = res.data.data.ofoFlowWork

        //     this.getWorkResList({pageNum: 1, pageSize: 10})
        //     this.getWorkThingList({pageNum: 1, pageSize: 10})
        //     this.navList = [
        //       {
        //         icon: 'iconfont icon-lvzhou_mingxi',
        //         text: this.ofoFlowWork.thingtypeName + '（明细）',
        //         isShow: this.ofoFlowWork.thingtype && this.ofoFlowWork.workkindmanagetype != '0',
        //       },
        //       {
        //         icon: 'iconfont icon-chanpin',
        //         text: this.ofoFlowWork.kindtypeName,
        //         isShow: this.ofoFlowWork.kindtype && this.ofoFlowWork.workkindmanagetype != '0'
        //       },
        //     ]
        //     let navArr = []
        //     this.navList.forEach((item, index) => {
        //       if(item.isShow) {
        //         navArr.push(index)
        //       }
        //     })
        //     this.isActive = navArr[0]
        //     for(let key in this.proTotal) {
        //       this.proTotal[key] = res.data.data.work[key]
        //     }
        //   }
        // })

      },
      getRowOrgRept(id) {
        this.rowTable = []
        this.loading2 = true
        let query = this.formInline.query.filter(item => item.isSearch == '0').map(val => {
          return {
            worktype: val.worktype,
            prop: val.prop,
            searchValue: val.searchValue,
          }
        })
        let cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
          return {
            cbdId: item.cbdId,
            editType: item.editType,
            resourceType: item.resourceType,
            value: item.value,
            endValue: '',
          }
        })
        this.$http.post(url.getOrgRept,
          {
            cfFlowReptId: this.activeId,
            // ofoItemId: this.ofoItemId,
            beginTime: this.date ? this.date[0] : '',
            endTime: this.date ? this.date[1] : '',
            queryList: query,
            selfownId: this.currentRow.id,
            secondId: id,
            kind: this.currentRow.kind,
            cbussDimeList
          }).then(res => {
          this.loading2 = false
          if(res.data.code == 200) {
            this.rowTable = res.data.data
          }
        })
      },
      getOrgRept() {
        this.tableData = []
        this.loading = true
        let query = this.formInline.query.filter(item => item.isSearch == '0').map(val => {
          return {
            worktype: val.worktype,
            prop: val.prop,
            searchValue: val.searchValue
          }
        })
        let cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
          return {
            cbdId: item.cbdId,
            editType: item.editType,
            resourceType: item.resourceType,
            value: item.value,
            endValue: '',
          }
        })
        this.$http.post(url.getOrgRept,
          {
            cfFlowReptId: this.activeId,
            // ofoItemId: this.ofoItemId,
            beginTime: this.date ? this.date[0] : '',
            endTime: this.date ? this.date[1] : '',
            dealName: this.khmc,
            queryList: query,
            cbussDimeList
          }).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.tableData = res.data.data
            if(this.cfOrgRept.flowRepttype !== '6' && this.cfOrgRept.flowRepttype != '7') {
              // console.log(JSON.parse(JSON.stringify(this.orgReptList[this.isActive].cfFlowReptcontList)));

              this.tableData.push({
                name: '合计',
                list: JSON.parse(JSON.stringify(this.orgReptList[this.isActive].cfFlowReptcontList)),
                secondList: []
              })
              this.tableData[this.tableData.length - 1].list.forEach(item => {
                item.reptValue = 0
                item.reptValue2 = 0
                this.tableData.forEach((val, index) => {
                  val.list.forEach(el => {
                    if(el.cfFlowReptcontId == item.cfFlowReptcontId && index != this.tableData.length - 1) {
                      // console.log(el.reptValue);
                      item.reptValue += Number(el.reptValue)
                    }
                  })
                  val.secondList.forEach(val1 => {
                    val1.list.forEach(el => {
                      if(el.cfFlowReptcontId == item.cfFlowReptcontId) {
                        // console.log(el.reptValue);
                        item.reptValue += Number(el.reptValue)
                        if(el.subdealtype == '70') {
                          item.reptValue2 += Number(el.reptValue2)
                        }
                      }
                    })
                  })
                })
                try {
                  item.reptValue = item.reptValue.toFixed(2)
                }catch (e) {

                }
              });
              // console.log(JSON.parse(JSON.stringify(this.tableData)));

            }else {
              if(this.cfOrgRept.isGroup == '0' && this.tableData.length) {
                this.$nextTick(function() {
                  this.$refs.monthlyPlanTable.setCurrentRow(this.tableData[0])
                })
                this.orgReptChildren = this.tableData[0].children
                this.currentRow = this.tableData[0]
                this.kindName = this.tableData[0].kindName
              }
            }

            // this.orgReptList[this.isActive].cfFlowReptcontList.forEach(item => {
            //   item.total = 0
            //   this.tableData.forEach(val => {
            //     val.list.forEach(el => {
            //       if(el.cfFlowReptcontId == item.cfFlowReptcontId) {
            //         // console.log(el.reptValue);
            //         item.total += Number(el.reptValue)
            //       }
            //     })
            //   })
            // });
          }
        })
      },
      changeCbResourceType(){
        let data = this.cBussDimeMap[this.activeNames]
        this.cbussDimeTree = []
        if (!data) {
          return
        }
        data.forEach(item => {
            item.children = JSON.parse(item.options).map(val => {
              return {
                label: val.optionLabel,
                value: val.optionValue
              }
            })
            item.label = item.dimeName
            item.value = null
            this.cbussDimeTree.push(item)
        })
      },
      handleNodeClick1(e, index) {
        this.cbussDimeTree[index].value = e.value
        // this.pageNum = 1
        // console.log(111111);
        // console.log(JSON.parse(JSON.stringify(this.cbussDimeTree)));

        this.getOrgRept()
      },
      handleChange() {
        this.getOrgRept()
      },
      handleClick(tab) {
        // console.log(this.activeId);
        this.isActive = tab.index
        this.getOrgRept()
      },
      // 查询按钮
      inquire() {
        // this.pageNum = 1
        this.getOrgRept()
      },
      // 重置按钮
      reset() {
        // for(let key in this.formInline) {
        //   this.formInline[key] = ""
        // }
        this.formInline.query.forEach(item => {
          item.searchValue = ''
        })

        this.date = [this.parseTime(new Date().getTime(), '{y}-{m}-{d}'), this.parseTime(new Date().getTime(), '{y}-{m}-{d}')]
        this.changeCbResourceType()
        this.getOrgRept()
        // this.formInline.cbowhId = null
        // this.pageNum = 1
        // this.getList()
      },
      initCbussDimeQuery(){
        if(this.cfOrgRept.flowRepttype === '6'){
          this.$http.get(url.getReptCbussDimeList + '?cfFlowReptId=' + this.activeId).then(res => {
            this.cBussDimeMap = res.data.data
            this.activeNames = Object.keys(this.cBussDimeMap)[0]
            this.changeCbResourceType()
            this.getOrgRept()
          })
        }else{
          this.cBussDimeMap = {}
          this.activeNames = ""
          this.cbussDimeTree = []
          this.getOrgRept()
        }
      }
    },
    watch:{
      $route:{
        handler(val, oldval){
          // console.log(val);//新路由信息
          // console.log(oldval);//老路由信息
          if(val.path == '/report/org' && this.orgReptList.length) {
            this.cfOrgRept = this.orgReptList.find(item => item.cfFlowReptId == val.query.cfFlowReptId)
            this.formInline.query = this.cfOrgRept.cfFlowReptcontList.map(item => {
              return {
                ...item,
                searchValue: ''
              }
            })
            this.activeId = this.cfOrgRept.cfFlowReptId
            this.isActive = this.orgReptList.findIndex(item => item.cfFlowReptId == val.query.cfFlowReptId)

            // console.log(this.$route.query);
            this.initCbussDimeQuery()
          }
        },
        // 深度观察监听
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>

.mutiple-contain {
  display: flex;
  .mutiple-left {
    //overflow: auto;
    /* flex-shrink: 0; */
    /* max-height: calc(100vh - 100px); */
    /* background: pink; */
    margin-right: 10px;
    ::v-deep .el-collapse-item__content {
      padding-bottom: 8px;
    }
    ::v-deep .el-collapse-item__header {
      height: 30px;
      padding-left: 10px;
      line-height: 30px;
    }
  }
  .mutiple-right {
    //flex: 1;
    overflow: auto;
    width: 100%;
  }
}
.grid-content {
  border-radius: 11px;
  padding: 10px;
  background-color: #fff;
}
.sift {
  width: 100%;
  background-color: #fff;
  box-shadow: 2px 3px 8px 0px rgba(208, 208, 208, 0.5);
  border-radius: 11px;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 16px;
}
.title {
  height: 14px;
  font-size: 14px;
  font-family: STHeitiSC-Medium, STHeitiSC;
  font-weight: 500;
  color: #282828;
  line-height: 15px;
  padding-left: 8px;
  border-left: #0c75e5 2px solid;
  margin-bottom: 16px;
  font-weight: bolder;
}
::v-deep .el-dialog {
  max-height: calc(100vh - 60px);
  overflow: hidden;
  .el-dialog__body {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
::v-deep .el-table{
  .el-table__body {
    // 吸底
    .fixed-row{
      /* display: inline-block; */
      position: sticky;
      bottom: 0;
      width: 100%;
      background: #f5f7fa;
    }
  }
}
.dialog-content {
  font-size: 16px;
  color: #000;
  .dialog-row {
    display: flex;
    margin-bottom: 10px;
    .row-left {
      color: #999;
    }
    .row-right {
      flex: 1;
      .log-list {
        display: flex;
        margin-bottom: 12px;

        .list-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 10px;
          margin-top: 10px;

          .list-dot {
            width: 16px;
            height: 16px;
            background-color: #1479E5;
            border-radius: 50%;
            margin-top: 8px;
            margin-bottom: 16px;
          }

          .list-line {
            width: 2px;
            flex: 1;
            background-color: #1479E5;
          }
        }

        .list-right {
          flex: 1;
          display: flex;
          justify-content: space-between;
          // align-items: center;
          border-bottom: 1px solid #cccccc;

          .list-text {
            flex: 1;
            // color: #999898;
            line-height: 40px;
            .list-row {
              display: flex;
              /* font-size: 20px; */
              .list-row-text {
                width: 45px;
              }
              .list-row-data {
                flex: 1;
                display: flex;
                align-items: center;
                .list-status {
                  color: #ffd361;
                  font-size: 14px;
                  padding: 2px 5px;
                  border: 1px solid #ffd361;
                  border-radius: 5px;
                  height: 14px;
                  line-height: 1;
                  margin-left: 5px;
                }
              }
            }
          }

          .list-appstatus {
            color: #1479E5;
          }
        }


      }
    }
  }
}
</style>
